import { Injectable } from '@angular/core';
import { SessionService } from '../session/session.service';
import { SystemConfig } from '../../config/system-config';
import { environment } from '../../../../environments/environment';
import { GameInfo } from '../../domain/signals/game-info';
import { SignalrMockData } from './signalr-mock-data';
import { BetStartService } from '../bet-start/bet-start.service';
import { DrawingService } from '../drawing/drawing.service';
import { DrawingHistoryService } from '../drawing-history/drawing-history.service';

@Injectable()
export class SignalrService {

  hubConnection: any;
  hubProxy: any;
  state: any = 0;

  public get isConnected(): boolean {
    return this.hubConnection && this.hubProxy;
  }

  constructor(public sessionService: SessionService,
              public betStartService: BetStartService,
              public drawingService: DrawingService,
              public drawingHistoryService: DrawingHistoryService) {
    if (!environment.production) {
      this.mockBetStart();
      this.mockDrawingDelayed();
    }
  }

  public init() {

    if (!jQuery || !jQuery.hubConnection) {
      //TODO: error ?
      return;
    }
    this.hubConnection = jQuery.hubConnection(SystemConfig.Endpoint.SIGNALR, {useDefaultPath: false});
    this.hubProxy = this.hubConnection.createHubProxy('kenoticker');

    this.hubConnection.connectionSlow(() => console.log('connection slow'));

    this.hubConnection.reconnecting(() => console.log('reconnecting'));

    this.hubConnection.reconnected(() => console.log('reconnected!'));

    this.hubConnection.disconnected(() => {
      //console.log('disconnected, restart in 5');
      setTimeout(() => this.init(), 5000);
    });

    this.hubConnection.stateChanged((state:any) => {
      console.log('state changed', state);
      this.state = state.newState;
    });
    this.hubConnection.error((error: any) => {
      console.log('error', error);
    });

    this.hubProxy.on('kenoEvent', (data: any) => {
      this.handleData(data.GameInfo as GameInfo);
    });

    this.hubConnection.start({'jsonp': false});
  }

  private handleData(gameInfo: any) {
      console.log('event', gameInfo);

      if (typeof gameInfo.Code != 'undefined' && gameInfo.Code != null) {
          // jackpot event, pe: "{"LastHitTime":"2000-01-01T00:00:00","LastHitStation":null,"LastHitValue":0,"Value":24.32,"Hit":false,"Code":"A07564","ApplicationType":0,"ApplicationSubType":0,"CycleID":0,"Timestamp":"2017-12-04T13:08:13.5644073+01:00","MessageID":0,"SessionGUID":null,"MessageGUID":null}"
          if (gameInfo.Hit && this.sessionService.history.filter(h => h.jackpotCode === gameInfo.Code).length > 0) {
              this.sessionService.jackpotWonAmount = gameInfo.LastHitValue;
              this.sessionService.jackpot = gameInfo.LastHitValue;
              this.sessionService.showJackpotWon = true;
          } else {
              this.sessionService.jackpot = gameInfo.Value;
          }
          return;
      }
      
    switch (gameInfo.State) {
      case GameInfo.States.WINNING_PLAN:
        // this.winningPlanService.setWinningPlan(gameInfo);
        break;
      case GameInfo.States.BET_START:
        this.betStartService.initializeBetStart(gameInfo);
        break;
      case GameInfo.States.DRAWING:
        this.drawingService.startDrawing(gameInfo);
        break;
      case GameInfo.States.DRAWING_HISTORY:
        this.drawingHistoryService.setDrawingHistory(gameInfo);
        break;
    }
  }

  private mockBetStart() {
    setTimeout(() => this.handleData(SignalrMockData.BET_START), 2000);
  }

  private mockDrawingDelayed() {
    setTimeout(() => this.handleData(SignalrMockData.DRAWING), SignalrMockData.BET_START.BetAcceptanceTime * 1000 + 2000);
  }
}




// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/signalr/signalr.service.ts